import { createElement, useMemo } from 'react';
import { Button, Dropdown, Space, Popconfirm } from 'antd';
import { DownOutlined } from '@ant-design/icons';
const buttonTypeMap = [
    {
        default: 'text',
        primary: 'link',
    },
    {
        default: '',
        primary: 'primary',
    }
];
export function useOperationColumn(options) {
    const formatedColumns = useMemo(() => {
        const { buttons, isTextMode, visibleCount = 0, ...othersParams } = options ?? {};
        if (!Array.isArray(buttons) || buttons.length <= 0) {
            return null;
        }
        const buttonType = buttonTypeMap[isTextMode ? 0 : 1];
        return ({
            ...othersParams,
            hideInSearch: true,
            render: (...args) => {
                const tempButtons = [...buttons];
                let visibleButtons = tempButtons;
                let otherButtons = [];
                if (visibleCount > 0) {
                    visibleButtons = tempButtons.splice(0, visibleCount);
                    otherButtons = tempButtons;
                }
                return (createElement(Space, null,
                    visibleButtons.map((item, index) => {
                        if (item.needConfirm) {
                            return (createElement(Popconfirm, { key: item.key ?? index, title: item.confirmText ?? '确定删除该数据？', onConfirm: () => item?.onClick?.(...args) },
                                createElement(Button, { type: buttonType[item.type] }, item.label)));
                        }
                        return (createElement(Button, { size: 'small', key: item.key ?? index, type: buttonType[item.type], onClick: () => item?.onClick?.(...args) }, item.label));
                    }),
                    otherButtons.length > 0 && (createElement(Dropdown, { menu: { items: otherButtons.map((item, index) => {
                                let labelEl = (createElement(Button, { size: 'small', key: item.key ?? index, type: buttonType[item.type], onClick: () => item?.onClick?.(...args) }, item.label));
                                if (item.needConfirm) {
                                    labelEl = (createElement(Popconfirm, { key: item.key ?? index, title: item.confirmText ?? '确定删除该数据？', onConfirm: () => item?.onClick?.(...args) },
                                        createElement(Button, { type: buttonType[item.type] }, item.label)));
                                }
                                return ({
                                    key: item.key ?? index,
                                    label: labelEl
                                });
                            }) } },
                        createElement("a", { onClick: e => e.preventDefault() },
                            createElement(DownOutlined, null))))));
            }
        });
    }, [options]);
    return formatedColumns;
}
